export const validateDate = ({ yearRoc, month, day}) => {
  // Convert yearRoc to AD year
  const year = parseInt(yearRoc) + 1911;

  // Validate month and day
  const monthInt = parseInt(month);
  const dayInt = parseInt(day);

  // Check if all inputs are valid integers
  if (isNaN(year) || isNaN(monthInt) || isNaN(dayInt)) {
    return ''; // Invalid date
  }

  // Create a Date object
  const date = new Date(year, monthInt - 1, dayInt);

  // Validate if the Date object matches the inputs
  if (
    date.getFullYear() === year &&
    date.getMonth() === monthInt - 1 &&
    date.getDate() === dayInt
  ) {
    // Return formatted date string
    return `${year}-${String(monthInt).padStart(2, '0')}-${String(dayInt).padStart(2, '0')}`;
  }
  return ''; // Invalid date
};
